import React from "react";
import { Button } from "@mui/material";

function GeneralInformationV2SaveBar(props) {
  const { translate, isLoading, isModified, onSave } = props;

  return (
    <div className="button-container-form-gi" style={{ fontSize: "12px" }}>
      <Button
        variant="contained"
        onClick={onSave}
        style={
          isModified && !isLoading
            ? { backgroundColor: "red", color: "white", marginLeft: "15px" }
            : { backgroundColor: "#1565C0", color: "white", marginLeft: "15px" }
        }
        disabled={isLoading}
        sx={{ height: "40px", width: "auto", marginLeft: "25px", marginRight: "30px", fontSize: "12px" }}
      >
        {isLoading
          ? translate("SavingModifications")
          : isModified
          ? translate("ClickToSave")
          : translate("SaveModifications")}
      </Button>
    </div>
  );
}

export default GeneralInformationV2SaveBar;
